var _a, _b;
import * as React from "react";
const uniq = (arr) => Array.from(new Set(arr));
const useIsomorphicLayoutEffect = typeof window !== "undefined" && (((_a = window.document) == null ? void 0 : _a.createElement) || ((_b = window.navigator) == null ? void 0 : _b.product) === "ReactNative") ? React.useLayoutEffect : React.useEffect;
function useCallbackRef(fn) {
  const ref = React.useRef(fn);
  useIsomorphicLayoutEffect(() => void (ref.current = fn), [fn]);
  return ref;
}
export {
  uniq,
  useCallbackRef,
  useIsomorphicLayoutEffect
};
//# sourceMappingURL=utils.js.map
